import { FlexContainer } from '@act/storybook';
import { SxProps } from '@mui/material';
import { PropsWithChildren } from 'react';

interface SlideProps extends PropsWithChildren {
  gap?: number;
  isVerticallyCentered?: boolean;
  sx?: SxProps;
}

export const Slide = ({
  children,
  gap = 6,
  isVerticallyCentered = true,
  sx,
}: SlideProps) => {
  return (
    <FlexContainer
      direction="column"
      width="100%"
      height="100%"
      padding="24px"
      alignItems="center"
      justifyContent={isVerticallyCentered ? 'center' : undefined}
      gap={gap}
      sx={sx}
    >
      {children}
    </FlexContainer>
  );
};
